import React from "react";
/* eslint-disable */
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, Stack,
  Card, Container
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const goodDetails = this.props.goodDetails;
    const farmerData = this.props.farmerData;

    return (
      <Container>
        <Stack spacing={2}>
          <Box display="flex" justifyContent="flex-end" p={2}>
            <Card sx={{ border: '2px solid black', width: '700px', borderRadius: "0" }}>
              <h5 style={{ marginLeft: '5px' }}>{farmerData.currentDate}</h5>
              <h4><center>{farmerData.groupName}</center></h4>
              <h4><center>FCC - {farmerData.factoryName}</center></h4>
              <h4><center>Goods Receive Note</center></h4>
              <h4><center>----------------</center></h4>
              <div>&nbsp;</div>
              <Card>
                <Stack>
                  <Box display="flex" justifyContent="flex-start" >
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Date</h4>
                    <h4 style={{ width: '220px' }}>{': ' + farmerData.orderDate.split('T')[0]}</h4>
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Txn No </h4>
                    <h4>{farmerData.invoiceNo == null ? ': -' : ': ' + farmerData.invoiceNo}</h4>
                  </Box>
                  <Box display="flex" justifyContent="flex-start" >
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Supplier</h4>
                    <h4 style={{ width: '220px' }}>{': ' + farmerData.fullName}</h4>
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Invoice Date </h4>
                    <h4>{': ' + farmerData.orderDate.split('T')[0]}</h4>
                  </Box>
                  <Box display="flex" justifyContent="flex-start" >
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Invoice No</h4>
                    <h4 style={{ width: '220px' }}>{farmerData.invoiceNo == null ? ': -' : ': ' + farmerData.invoiceNo}</h4>
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Inv Amount</h4>
                    <h4>{': ' + parseFloat(farmerData.total).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h4>
                  </Box>
                  <Box display="flex" justifyContent="flex-start" >
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Order No</h4>
                    <h4 style={{ width: '220px' }}>{': ' + farmerData.orderNo}</h4>
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Invoice Type</h4>
                    <h4>{farmerData.invoiceType == null ? ": -" : farmerData.invoiceType == 4 ? ": Credit" : ": Cash"}</h4>

                  </Box>
                </Stack>
                <TableContainer >
                  <Table size="small" aria-label="caption table">
                    <TableHead>
                      <TableRow sx={{ borderTop: '2px solid black', borderBottom: '2px solid black' }}>
                        <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>Item</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>Description</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>U Size</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }} align={'right'}>U Price</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }} align={'right'}>Rec Qty</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }} align={'right'}>Amount</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody sx={{ borderBottom: '2px solid black' }}>
                      {goodDetails.map((data, index) => (
                        <TableRow sx={{ minHeight: "5px", height: "5px" }} key={index}>
                          <TableCell sx={{ fontWeight: 'bold' }} align={'left'} >
                            {data.productCode}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>
                            <Stack direction={{ xs: 'column', sm: 'row' }}>
                              {data.productName}
                            </Stack>
                            {data.isSpecialOrder == true ?
                              <Stack direction={{ xs: 'column', sm: 'row' }} >
                                <h5 style={{ marginTop: '-5px' }}>{data.performOrderCode}</h5>
                              </Stack> : null}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>
                            {data.measuringUnit == 2 ? '1 KG' : '1 Unit'}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 'bold' }} align={'right'} >
                            {parseFloat(data.realizedPrice).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 'bold' }} align={'right'} >
                            {parseFloat(data.netAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 'bold' }} align={'right'} >
                            {parseFloat(data.totalAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Stack>
                  <Box display="flex" justifyContent="flex-end">
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Gross Total</h4>
                    <h4>:</h4>
                    <h4 style={{ width: '85px', textAlign: 'right', marginRight: '15px' }}>{parseFloat(farmerData.total).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h4>
                  </Box>
                  <Box display="flex" justifyContent="flex-end">
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Discount</h4>
                    <h4>:</h4>
                    <h4 style={{ width: '85px', textAlign: 'right', marginRight: '15px' }}>0.00</h4>
                  </Box>
                  <Box display="flex" justifyContent="flex-end">
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Over Chg</h4>
                    <h4>:</h4>
                    <h4 style={{ width: '85px', textAlign: 'right', marginRight: '15px' }}>0.00</h4>
                  </Box>
                  <Box display="flex" justifyContent="flex-end">
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Not Supply</h4>
                    <h4>:</h4>
                    <h4 style={{ width: '85px', textAlign: 'right', marginRight: '15px' }}>0.00</h4>
                  </Box>
                  <Box display="flex" justifyContent="flex-end">
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Rounding Diff</h4>
                    <h4>:</h4>
                    <h4 style={{ width: '85px', textAlign: 'right', marginRight: '15px' }}>0.00</h4>
                  </Box>
                  <Box display="flex" justifyContent="flex-end">
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Adjustment</h4>
                    <h4>:</h4>
                    <h4 style={{ width: '85px', textAlign: 'right', marginRight: '15px' }}>0.00</h4>
                  </Box>
                  <Box display="flex" justifyContent="flex-end">
                    <h4>------------------</h4>
                  </Box>
                  <Box display="flex" justifyContent="flex-end">
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Invoice Value</h4>
                    <h4>:</h4>
                    <h4 style={{ width: '85px', textAlign: 'right', marginRight: '15px' }}>{parseFloat(farmerData.total).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h4>
                  </Box>
                  <Box display="flex" justifyContent="flex-end">
                    <h4>===========</h4>
                  </Box>
                  <div>&nbsp;</div>
                  <Box display="flex" justifyContent="flex-start" >
                    <h4 style={{ marginLeft: '5px', width: '120px' }}>Prepared By</h4>
                    <h4 style={{ width: '120px' }}>------------------</h4>
                    <h4 style={{ marginLeft: '50px', width: '120px' }}>Checked By</h4>
                    <h4 style={{ width: '120px' }}>------------------</h4>
                  </Box>
                </Stack>
                <div>&nbsp;</div>
              </Card>
            </Card>
          </Box>
        </Stack>
      </Container>
    );
  }
}
